class Sequence {
  constructor(start, delta) {
    this.value = start - delta;
    this.delta = delta;
  }

  next = () => {
    this.value += this.delta;
    return this.value;
  };
}

export default Sequence;



// WEBPACK FOOTER //
// ./src/utilities/sequence.js